import { render, staticRenderFns } from "./DataEntry.vue?vue&type=template&id=cbfd67fe&scoped=true&"
import script from "./DataEntry.vue?vue&type=script&lang=js&"
export * from "./DataEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfd67fe",
  null
  
)

export default component.exports